import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VersionHistory } from 'companySettings/components/PartFinderVersionHistory';
import { useGetPartFinderFamilyVersions } from 'companySettings/hooks';
import { IPartFinderFamily, IPartFinderFamilyChanges } from 'companySettings/types';

import { PartFinderFamilyCompare } from './PartFinderFamilyCompare';
import { formatFamilyChanges } from '../utils';

interface IProps {
  family: IPartFinderFamily;
}

// The status pill of an open family; it opens the published versions, two of which can be
// compared.
export const PartFinderFamilyVersionHistory = ({ family }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const {
    data: versions = [],
    isLoading,
    isError,
  } = useGetPartFinderFamilyVersions(family.id, isOpen);

  return (
    <VersionHistory
      status={family.status}
      versionNumber={family.versionNumber}
      versions={versions}
      isLoading={isLoading}
      isError={isError}
      errorMessage={t('errorTitlePartFinderFamilyVersionsFetch')}
      formatChanges={(changes: IPartFinderFamilyChanges, isPublish: boolean) =>
        formatFamilyChanges(changes, t, isPublish)
      }
      renderCompare={(fromVersionId, toVersionId, isCompareOpen, onClose) => (
        <PartFinderFamilyCompare
          fromVersionId={fromVersionId}
          toVersionId={toVersionId}
          isOpen={isCompareOpen}
          onClose={onClose}
        />
      )}
      onOpenChange={setIsOpen}
    />
  );
};
